export default __webpack_public_path__ + "static/media/contactus.b3501113.md";